export const NOTIFICATIONS_MUTATIONS = {
    SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
    ADD_NOTIFICATION: "ADD_NOTIFICATION",
    MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
    MARK_SINGLE_AS_READ: "MARK_SINGLE_AS_READ",
    REMOVE_NOTIFICATIONS_BY_TYPE: "REMOVE_NOTIFICATIONS_BY_TYPE"
};